import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { AddressModel } from '../models/address-related/AddressModel';
import { SearchAddressResultModel } from '../models/search-related/SearchAddressResultModel';

@Injectable()
export class AddressService {

    private actionUrl: string;
    private headers: Headers;
    private uData: any;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/EntityAddress/`;
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public GetAll = (id: string): Observable<AddressModel[]> => {
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.get(this.actionUrl + id, options).map(res => res.json());
    }

    public Search = (searchParams: any): Observable<SearchAddressResultModel> => {
        this.setHeaders();
        let params = new URLSearchParams();
        for (let key in searchParams) {
            if (searchParams.hasOwnProperty(key)) {
                let val = searchParams[key];
                params.set(key, val);
            }
        }

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public Create = (newAddress: AddressModel): Observable<Response> => {
        this.setHeaders();
        newAddress.UserId = this.uData.sub;
        let options = new RequestOptions({ headers: this.headers });
        return this._http.post(this.actionUrl, JSON.stringify(newAddress), options);
    }

    public Update = (address: AddressModel): Observable<Response> => {
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.put(this.actionUrl, JSON.stringify(address), options);
    }

    public Delete = (address: AddressModel): Observable<Response> => {
        this.setHeaders();
        let params = new URLSearchParams();
        params.set('entityId', address.EntityId);
        params.set('addressId', address.AddressId);
        params.set('defaultItem', address.DefaultItem.toString());

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.delete(this.actionUrl, options);
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/address-modal/address.service.ts